export const MENU_STATES = 'MENU_STATES';